"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pl_1 = require("../../../backend/src/app/acl_module/config/i18n/pl");
const pl_2 = __importDefault(require("./landing/pl"));
const onboarding_tooltip_1 = __importDefault(require("./pl/onboarding_tooltip"));
const knowledge_picker_1 = __importDefault(require("./pl/knowledge_picker"));
const app_page_1 = __importDefault(require("./pl/app_page"));
const app_intext_1 = __importDefault(require("./pl/app_intext"));
const modal_share_1 = __importDefault(require("./pl/modal_share"));
const modal_settings_1 = __importDefault(require("./pl/modal_settings"));
const chat_entry_1 = __importDefault(require("./pl/chat_entry"));
const user_form_1 = __importDefault(require("./pl/user_form"));
const slot_goal_1 = __importDefault(require("./pl/slot_goal"));
const slot_target_1 = __importDefault(require("./pl/slot_target"));
const slot_format_1 = __importDefault(require("./pl/slot_format"));
const slotData_create_1 = __importDefault(require("./pl/slotData_create"));
const slotData_load_1 = __importDefault(require("./pl/slotData_load"));
const slotData_form_1 = __importDefault(require("./pl/slotData_form"));
const slotData_type_1 = __importDefault(require("./pl/slotData_type"));
const app_pagination_1 = __importDefault(require("./pl/app_pagination"));
const payment_validation_1 = __importDefault(require("./pl/payment_validation"));
const payment_status_1 = __importDefault(require("./pl/payment_status"));
const payment_stripe_1 = __importDefault(require("./pl/payment_stripe"));
const payment_provider_1 = __importDefault(require("./pl/payment_provider"));
const payment_confirmed_1 = __importDefault(require("./pl/payment_confirmed"));
const route_payment_1 = __importDefault(require("./pl/route_payment"));
const payment_search_1 = __importDefault(require("./pl/payment_search"));
const payment_preview_1 = __importDefault(require("./pl/payment_preview"));
const user_roles_1 = __importDefault(require("./pl/user_roles"));
const user_grade_1 = __importDefault(require("./pl/user_grade"));
const company_preview_1 = __importDefault(require("./pl/company_preview"));
const company_tooltips_1 = __importDefault(require("./pl/company_tooltips"));
const company_form_1 = __importDefault(require("./pl/company_form"));
const access_status_1 = __importDefault(require("./pl/access_status"));
const access_list_1 = __importDefault(require("./pl/access_list"));
const avatar_processing_1 = __importDefault(require("./pl/avatar_processing"));
const avatar_form_1 = __importDefault(require("./pl/avatar_form"));
const webhook_eventTypes_1 = __importDefault(require("./pl/webhook_eventTypes"));
const webhook_cronIntervals_1 = __importDefault(require("./pl/webhook_cronIntervals"));
const tools_webSearch_1 = __importDefault(require("./pl/tools_webSearch"));
const tools_imgGen_1 = __importDefault(require("./pl/tools_imgGen"));
const tools_convoTags_1 = __importDefault(require("./pl/tools_convoTags"));
const tools_galleryTags_1 = __importDefault(require("./pl/tools_galleryTags"));
const tools_detectContactData_1 = __importDefault(require("./pl/tools_detectContactData"));
const tools_detectTasks_1 = __importDefault(require("./pl/tools_detectTasks"));
const tools_productCompare_1 = __importDefault(require("./pl/tools_productCompare"));
const tools_askForVoucher_1 = __importDefault(require("./pl/tools_askForVoucher"));
const tools_offerCreator_1 = __importDefault(require("./pl/tools_offerCreator"));
const tools_quickOffer_1 = __importDefault(require("./pl/tools_quickOffer"));
const tools_sendContactForm_1 = __importDefault(require("./pl/tools_sendContactForm"));
const tools_apiTool_1 = __importDefault(require("./pl/tools_apiTool"));
const tools_productAPISearch_1 = __importDefault(require("./pl/tools_productAPISearch"));
const tools_dynamicListings_1 = __importDefault(require("./pl/tools_dynamicListings"));
const tools_personalData_1 = __importDefault(require("./pl/tools_personalData"));
const tools_rag_1 = __importDefault(require("./pl/tools_rag"));
const tools_aiFormAnalyzer_1 = __importDefault(require("./pl/tools_aiFormAnalyzer"));
const tools_communications_search_1 = __importDefault(require("./pl/tools_communications_search"));
const tools_productCard_1 = __importDefault(require("./pl/tools_productCard"));
const avatar_common_1 = __importDefault(require("./pl/avatar_common"));
const avatar_active_1 = __importDefault(require("./pl/avatar_active"));
const avatar_tooltips_1 = __importDefault(require("./pl/avatar_tooltips"));
const avatar_knowledge_1 = __importDefault(require("./pl/avatar_knowledge"));
const avatar_preview_1 = __importDefault(require("./pl/avatar_preview"));
const style_form_1 = __importDefault(require("./pl/style_form"));
const botTest_preview_1 = __importDefault(require("./pl/botTest_preview"));
const botTest_testResults_1 = __importDefault(require("./pl/botTest_testResults"));
const accountGrade_list_1 = __importDefault(require("./pl/accountGrade_list"));
const accountGrade_form_1 = __importDefault(require("./pl/accountGrade_form"));
const limits_avatar_1 = __importDefault(require("./pl/limits_avatar"));
const limits_user_1 = __importDefault(require("./pl/limits_user"));
const limits_project_1 = __importDefault(require("./pl/limits_project"));
const limits_knowledge_1 = __importDefault(require("./pl/limits_knowledge"));
const limits_customModel_1 = __importDefault(require("./pl/limits_customModel"));
const limits_writingStyles_1 = __importDefault(require("./pl/limits_writingStyles"));
const limits_advanced_prompts_1 = __importDefault(require("./pl/limits_advanced-prompts"));
const limits_prompt_assist_1 = __importDefault(require("./pl/limits_prompt-assist"));
const limits_anti_hallucination_1 = __importDefault(require("./pl/limits_anti-hallucination"));
const limits_advanced_reports_1 = __importDefault(require("./pl/limits_advanced-reports"));
const limits_chat_thread_sharing_1 = __importDefault(require("./pl/limits_chat-thread-sharing"));
const limits_custom_branding_1 = __importDefault(require("./pl/limits_custom-branding"));
const limits_widgets_1 = __importDefault(require("./pl/limits_widgets"));
const limits_voice_agent_1 = __importDefault(require("./pl/limits_voice-agent"));
const limits_upgrade_1 = __importDefault(require("./pl/limits_upgrade"));
const voice_chat_error_1 = __importDefault(require("./pl/voice-chat_error"));
const email_pass_reset_1 = __importDefault(require("./pl/email_pass_reset"));
const email_activation_1 = __importDefault(require("./pl/email_activation"));
const email_upgrade_1 = __importDefault(require("./pl/email_upgrade"));
const email_payment_1 = __importDefault(require("./pl/email_payment"));
const register_complete_1 = __importDefault(require("./pl/register_complete"));
const password_reset_1 = __importDefault(require("./pl/password_reset"));
const accountGrade_preview_1 = __importDefault(require("./pl/accountGrade_preview"));
const account_upgrade_1 = __importDefault(require("./pl/account_upgrade"));
const account_grades_1 = __importDefault(require("./pl/account_grades"));
const userGroup_form_1 = __importDefault(require("./pl/userGroup_form"));
const userGroup_error_1 = __importDefault(require("./pl/userGroup_error"));
const user_profile_1 = __importDefault(require("./pl/user_profile"));
const table_controls_1 = __importDefault(require("./pl/table_controls"));
const route_settings_1 = __importDefault(require("./pl/route_settings"));
const route_style_1 = __importDefault(require("./pl/route_style"));
const route_company_1 = __importDefault(require("./pl/route_company"));
const route_user_1 = __importDefault(require("./pl/route_user"));
const route_accountGrade_1 = __importDefault(require("./pl/route_accountGrade"));
const route_userGroup_1 = __importDefault(require("./pl/route_userGroup"));
const route_user_group_1 = __importDefault(require("./pl/route_user_group"));
const route_branch_1 = __importDefault(require("./pl/route_branch"));
const route_profession_1 = __importDefault(require("./pl/route_profession"));
const route_avatar_1 = __importDefault(require("./pl/route_avatar"));
const route_conversation_1 = __importDefault(require("./pl/route_conversation"));
const route_botTest_1 = __importDefault(require("./pl/route_botTest"));
const route_tutorial_1 = __importDefault(require("./pl/route_tutorial"));
const tutorial_start_1 = __importDefault(require("./pl/tutorial_start"));
const tutorial_new_section_1 = __importDefault(require("./pl/tutorial_new-section"));
const tutorial_create_1 = __importDefault(require("./pl/tutorial_create"));
const tutorial_edit_1 = __importDefault(require("./pl/tutorial_edit"));
const tutorial_preview_1 = __importDefault(require("./pl/tutorial_preview"));
const tutorial_delete_1 = __importDefault(require("./pl/tutorial_delete"));
const tutorial_list_1 = __importDefault(require("./pl/tutorial_list"));
const tutorial_search_1 = __importDefault(require("./pl/tutorial_search"));
const tutorial_form_1 = __importDefault(require("./pl/tutorial_form"));
const tutorial_errors_1 = __importDefault(require("./pl/tutorial_errors"));
const tutorial_validation_1 = __importDefault(require("./pl/tutorial_validation"));
const tutorial_todos_1 = __importDefault(require("./pl/tutorial_todos"));
const tutorial_statistics_1 = __importDefault(require("./pl/tutorial_statistics"));
const botTest_create_1 = __importDefault(require("./pl/botTest_create"));
const botTest_edit_1 = __importDefault(require("./pl/botTest_edit"));
const botTest_tester_1 = __importDefault(require("./pl/botTest_tester"));
const botTest_target_1 = __importDefault(require("./pl/botTest_target"));
const botTest_list_1 = __importDefault(require("./pl/botTest_list"));
const botTest_actions_1 = __importDefault(require("./pl/botTest_actions"));
const route_ai_1 = __importDefault(require("./pl/route_ai"));
const ai_models_1 = __importDefault(require("./pl/ai_models"));
const ai_com_1 = __importDefault(require("./pl/ai_com"));
const ai_fields_1 = __importDefault(require("./pl/ai_fields"));
const ai_controls_1 = __importDefault(require("./pl/ai_controls"));
const ai_assist_suggestions_1 = __importDefault(require("./pl/ai-assist_suggestions"));
const ai_suggestions_1 = __importDefault(require("./pl/ai_suggestions"));
const ai_assist_1 = __importDefault(require("./pl/ai_assist"));
const conversation_type_1 = __importDefault(require("./pl/conversation_type"));
const conversation_agent_1 = __importDefault(require("./pl/conversation_agent"));
const conversation_session_1 = __importDefault(require("./pl/conversation_session"));
const conversation_avatar_1 = __importDefault(require("./pl/conversation_avatar"));
const conversation_voice_1 = __importDefault(require("./pl/conversation_voice"));
const conversation_clear_1 = __importDefault(require("./pl/conversation_clear"));
const conversation_auto_1 = __importDefault(require("./pl/conversation_auto"));
const conversation_start_1 = __importDefault(require("./pl/conversation_start"));
const conversation_stop_1 = __importDefault(require("./pl/conversation_stop"));
const conversation_recording_1 = __importDefault(require("./pl/conversation_recording"));
const conversation_user_1 = __importDefault(require("./pl/conversation_user"));
const conversation_processing_1 = __importDefault(require("./pl/conversation_processing"));
const recording_start_1 = __importDefault(require("./pl/recording_start"));
const recording_process_1 = __importDefault(require("./pl/recording_process"));
const conversation_end_1 = __importDefault(require("./pl/conversation_end"));
const message_send_1 = __importDefault(require("./pl/message_send"));
const microphone_access_1 = __importDefault(require("./pl/microphone_access"));
const conversation_interruption_1 = __importDefault(require("./pl/conversation_interruption"));
const conversations_search_1 = __importDefault(require("./pl/conversations_search"));
const conversations_date_1 = __importDefault(require("./pl/conversations_date"));
const conversations_error_1 = __importDefault(require("./pl/conversations_error"));
const conversations_delete_1 = __importDefault(require("./pl/conversations_delete"));
const conversations_favorite_1 = __importDefault(require("./pl/conversations_favorite"));
const conversations_tooltips_1 = __importDefault(require("./pl/conversations_tooltips"));
const route_knowledge_1 = __importDefault(require("./pl/route_knowledge"));
const route_knowledgeProject_1 = __importDefault(require("./pl/route_knowledgeProject"));
const knowledge_ragStatus_1 = __importDefault(require("./pl/knowledge_ragStatus"));
const knowledge_statusInfo_1 = __importDefault(require("./pl/knowledge_statusInfo"));
const knowledge_title_1 = __importDefault(require("./pl/knowledge_title"));
const knowledge_description_1 = __importDefault(require("./pl/knowledge_description"));
const knowledge_content_1 = __importDefault(require("./pl/knowledge_content"));
const knowledge_tags_1 = __importDefault(require("./pl/knowledge_tags"));
const knowledge_active_1 = __importDefault(require("./pl/knowledge_active"));
const knowledge_filter_1 = __importDefault(require("./pl/knowledge_filter"));
const knowledge_project_1 = __importDefault(require("./pl/knowledge_project"));
const project_form_1 = __importDefault(require("./pl/project_form"));
const project_name_1 = __importDefault(require("./pl/project_name"));
const project_description_1 = __importDefault(require("./pl/project_description"));
const project_icon_1 = __importDefault(require("./pl/project_icon"));
const knowledge_native_1 = __importDefault(require("./pl/knowledge_native"));
const knowledge_form_1 = __importDefault(require("./pl/knowledge_form"));
const knowledge_bulk_upload_1 = __importDefault(require("./pl/knowledge_bulk_upload"));
const knowledge_preview_1 = __importDefault(require("./pl/knowledge_preview"));
const knowledgeProject_form_1 = __importDefault(require("./pl/knowledgeProject_form"));
const knowledgeProject_name_1 = __importDefault(require("./pl/knowledgeProject_name"));
const knowledgeProject_description_1 = __importDefault(require("./pl/knowledgeProject_description"));
const knowledgeProject_icon_1 = __importDefault(require("./pl/knowledgeProject_icon"));
const chat_teaser_1 = __importDefault(require("./pl/chat_teaser"));
const chat_heading_1 = __importDefault(require("./pl/chat_heading"));
const chat_config_1 = __importDefault(require("./pl/chat_config"));
const chat_noCredits_1 = __importDefault(require("./pl/chat_noCredits"));
const file_upload_1 = __importDefault(require("./pl/file_upload"));
const file_clipboard_1 = __importDefault(require("./pl/file_clipboard"));
const trainer_reset_1 = __importDefault(require("./pl/trainer_reset"));
const trainer_tab_1 = __importDefault(require("./pl/trainer_tab"));
const trainer_upload_1 = __importDefault(require("./pl/trainer_upload"));
const trainer_config_1 = __importDefault(require("./pl/trainer_config"));
const trainer_progress_1 = __importDefault(require("./pl/trainer_progress"));
const trainer_results_1 = __importDefault(require("./pl/trainer_results"));
const trainer_instructions_1 = __importDefault(require("./pl/trainer_instructions"));
const chat_sync_1 = __importDefault(require("./pl/chat_sync"));
const ai_chat_1 = __importDefault(require("./pl/ai_chat"));
const branch_list_1 = __importDefault(require("./pl/branch_list"));
const branch_create_1 = __importDefault(require("./pl/branch_create"));
const branch_edit_1 = __importDefault(require("./pl/branch_edit"));
const branch_search_1 = __importDefault(require("./pl/branch_search"));
const branch_delete_1 = __importDefault(require("./pl/branch_delete"));
const branch_form_1 = __importDefault(require("./pl/branch_form"));
const profession_list_1 = __importDefault(require("./pl/profession_list"));
const profession_create_1 = __importDefault(require("./pl/profession_create"));
const profession_edit_1 = __importDefault(require("./pl/profession_edit"));
const profession_search_1 = __importDefault(require("./pl/profession_search"));
const profession_delete_1 = __importDefault(require("./pl/profession_delete"));
const profession_form_1 = __importDefault(require("./pl/profession_form"));
const profession_common_1 = __importDefault(require("./pl/profession_common"));
const step_shared_1 = __importDefault(require("./pl/step_shared"));
const step_list_1 = __importDefault(require("./pl/step_list"));
const step_create_1 = __importDefault(require("./pl/step_create"));
const step_edit_1 = __importDefault(require("./pl/step_edit"));
const step_search_1 = __importDefault(require("./pl/step_search"));
const step_delete_1 = __importDefault(require("./pl/step_delete"));
const step_form_1 = __importDefault(require("./pl/step_form"));
const question_list_1 = __importDefault(require("./pl/question_list"));
const question_create_1 = __importDefault(require("./pl/question_create"));
const question_edit_1 = __importDefault(require("./pl/question_edit"));
const question_search_1 = __importDefault(require("./pl/question_search"));
const question_delete_1 = __importDefault(require("./pl/question_delete"));
const question_form_1 = __importDefault(require("./pl/question_form"));
const question_type_1 = __importDefault(require("./pl/question_type"));
const onboarding_intro_1 = __importDefault(require("./pl/onboarding_intro"));
const onboarding_list_1 = __importDefault(require("./pl/onboarding_list"));
const onboarding_create_1 = __importDefault(require("./pl/onboarding_create"));
const onboarding_edit_1 = __importDefault(require("./pl/onboarding_edit"));
const onboarding_search_1 = __importDefault(require("./pl/onboarding_search"));
const onboarding_delete_1 = __importDefault(require("./pl/onboarding_delete"));
const onboarding_status_1 = __importDefault(require("./pl/onboarding_status"));
const onboarding_wizard_1 = __importDefault(require("./pl/onboarding_wizard"));
const onboarding_benefits_1 = __importDefault(require("./pl/onboarding_benefits"));
const onboarding_button_1 = __importDefault(require("./pl/onboarding_button"));
const onboarding_image_1 = __importDefault(require("./pl/onboarding_image"));
const onboarding_faq_1 = __importDefault(require("./pl/onboarding_faq"));
const onboarding_setup_1 = __importDefault(require("./pl/onboarding_setup"));
const onboarding_knowledge_1 = __importDefault(require("./pl/onboarding_knowledge"));
const onboarding_avatar_1 = __importDefault(require("./pl/onboarding_avatar"));
const onboarding_profession_1 = __importDefault(require("./pl/onboarding_profession"));
const voices_david_1 = __importDefault(require("./pl/voices_david"));
const voices_bradford_1 = __importDefault(require("./pl/voices_bradford"));
const voices_clyde_1 = __importDefault(require("./pl/voices_clyde"));
const voices_natalie_1 = __importDefault(require("./pl/voices_natalie"));
const voices_jane_1 = __importDefault(require("./pl/voices_jane"));
const voices_magdalena_1 = __importDefault(require("./pl/voices_magdalena"));
const onboarding_records_1 = __importDefault(require("./pl/onboarding_records"));
const onboarding_record_1 = __importDefault(require("./pl/onboarding_record"));
const onboarding_warning_1 = __importDefault(require("./pl/onboarding_warning"));
const onboarding_step_1 = __importDefault(require("./pl/onboarding_step"));
const onboarding_questions_1 = __importDefault(require("./pl/onboarding_questions"));
const onboarding_pagination_1 = __importDefault(require("./pl/onboarding_pagination"));
const onboarding_progress_1 = __importDefault(require("./pl/onboarding_progress"));
const onboarding_stats_1 = __importDefault(require("./pl/onboarding_stats"));
const onboarding_view_1 = __importDefault(require("./pl/onboarding_view"));
const onboarding_pick_1 = __importDefault(require("./pl/onboarding_pick"));
const onboarding_error_1 = __importDefault(require("./pl/onboarding_error"));
const onboarding_success_1 = __importDefault(require("./pl/onboarding_success"));
const onboarding_notify_1 = __importDefault(require("./pl/onboarding_notify"));
const login_username_1 = __importDefault(require("./pl/login_username"));
const login_password_1 = __importDefault(require("./pl/login_password"));
const login_form_1 = __importDefault(require("./pl/login_form"));
const register_name_1 = __importDefault(require("./pl/register_name"));
const register_username_1 = __importDefault(require("./pl/register_username"));
const register_email_1 = __importDefault(require("./pl/register_email"));
const register_password_1 = __importDefault(require("./pl/register_password"));
const register_repeat_password_1 = __importDefault(require("./pl/register_repeat_password"));
const register_form_1 = __importDefault(require("./pl/register_form"));
const register_company_1 = __importDefault(require("./pl/register_company"));
const activate_hero_1 = __importDefault(require("./pl/activate_hero"));
const activate_page_1 = __importDefault(require("./pl/activate_page"));
const activate_loading_1 = __importDefault(require("./pl/activate_loading"));
const activate_success_1 = __importDefault(require("./pl/activate_success"));
const activate_error_1 = __importDefault(require("./pl/activate_error"));
const activate_button_1 = __importDefault(require("./pl/activate_button"));
const settings_general_1 = __importDefault(require("./pl/settings_general"));
const settings_socialMedia_1 = __importDefault(require("./pl/settings_socialMedia"));
const settings_status_1 = __importDefault(require("./pl/settings_status"));
const settings_rag_1 = __importDefault(require("./pl/settings_rag"));
const settings_credit_1 = __importDefault(require("./pl/settings_credit"));
const rag_file_1 = __importDefault(require("./pl/rag_file"));
const settings_googleDrive_1 = __importDefault(require("./pl/settings_googleDrive"));
const googleDrive_picker_1 = __importDefault(require("./pl/googleDrive_picker"));
const route_reports_1 = __importDefault(require("./pl/route_reports"));
const reports_access_1 = __importDefault(require("./pl/reports_access"));
const reports_costReports_1 = __importDefault(require("./pl/reports_costReports"));
const reports_export_1 = __importDefault(require("./pl/reports_export"));
const reports_period_1 = __importDefault(require("./pl/reports_period"));
const cost_preview_1 = __importDefault(require("./pl/cost_preview"));
const chat_settings_1 = __importDefault(require("./pl/chat_settings"));
const config_tooltips_1 = __importDefault(require("./pl/config_tooltips"));
const share_conversation_1 = __importDefault(require("./pl/share_conversation"));
const autocomplete_triggers_1 = __importDefault(require("./pl/autocomplete_triggers"));
const reports_shared_1 = __importDefault(require("./pl/reports_shared"));
const acl_table_1 = __importDefault(require("./pl/acl_table"));
const shortcuts_button_1 = __importDefault(require("./pl/shortcuts_button"));
const shortcuts_table_1 = __importDefault(require("./pl/shortcuts_table"));
const shortcuts_knowledge_1 = __importDefault(require("./pl/shortcuts_knowledge"));
const shortcuts_new_1 = __importDefault(require("./pl/shortcuts_new"));
const shortcuts_settings_1 = __importDefault(require("./pl/shortcuts_settings"));
const shortcuts_find_1 = __importDefault(require("./pl/shortcuts_find"));
const shortcuts_prompt_1 = __importDefault(require("./pl/shortcuts_prompt"));
const currency_error_1 = __importDefault(require("./pl/currency_error"));
const nav_avatar_1 = __importDefault(require("./pl/nav_avatar"));
const nav_model_1 = __importDefault(require("./pl/nav_model"));
const nav_ai_1 = __importDefault(require("./pl/nav_ai"));
const googleDrive_directoryPicker_1 = __importDefault(require("./pl/googleDrive_directoryPicker"));
const knowledge_bulkUpload_1 = __importDefault(require("./pl/knowledge_bulkUpload"));
const rag_settings_1 = __importDefault(require("./pl/rag_settings"));
const dblogs_filter_1 = __importDefault(require("./pl/dblogs_filter"));
const dblogs_results_1 = __importDefault(require("./pl/dblogs_results"));
const dblogs_col_1 = __importDefault(require("./pl/dblogs_col"));
const dblogs_error_1 = __importDefault(require("./pl/dblogs_error"));
const dblogs_search_1 = __importDefault(require("./pl/dblogs_search"));
const dblogs_page_1 = __importDefault(require("./pl/dblogs_page"));
const route_dblogs_1 = __importDefault(require("./pl/route_dblogs"));
const db_operation_1 = __importDefault(require("./pl/db_operation"));
const socialMediaPlan_wip_1 = __importDefault(require("./pl/socialMediaPlan_wip"));
const socialMediaPlan_nav_1 = __importDefault(require("./pl/socialMediaPlan_nav"));
const socialMediaPlan_dashboard_1 = __importDefault(require("./pl/socialMediaPlan_dashboard"));
const socialMediaPlan_stat_1 = __importDefault(require("./pl/socialMediaPlan_stat"));
const socialMediaPlan_tab_1 = __importDefault(require("./pl/socialMediaPlan_tab"));
const socialMediaPlan_history_1 = __importDefault(require("./pl/socialMediaPlan_history"));
const socialMediaPlan_library_1 = __importDefault(require("./pl/socialMediaPlan_library"));
const socialMediaPlan_filter_1 = __importDefault(require("./pl/socialMediaPlan_filter"));
const socialMediaPlan_drawer_1 = __importDefault(require("./pl/socialMediaPlan_drawer"));
const socialMediaPlan_post_1 = __importDefault(require("./pl/socialMediaPlan_post"));
const socialMediaPlan_approvalQueue_1 = __importDefault(require("./pl/socialMediaPlan_approvalQueue"));
const socialMediaPlan_ai_1 = __importDefault(require("./pl/socialMediaPlan_ai"));
const socialMediaPlan_channels_1 = __importDefault(require("./pl/socialMediaPlan_channels"));
const socialMediaPlan_analytics_1 = __importDefault(require("./pl/socialMediaPlan_analytics"));
const socialMediaPlan_creator_1 = __importDefault(require("./pl/socialMediaPlan_creator"));
const socialMediaPlan_platformNotConnected_1 = __importDefault(require("./pl/socialMediaPlan_platformNotConnected"));
const socialMediaPlan_brief_1 = __importDefault(require("./pl/socialMediaPlan_brief"));
const socialMediaPlan_schedule_1 = __importDefault(require("./pl/socialMediaPlan_schedule"));
const socialMediaPlan_step_1 = __importDefault(require("./pl/socialMediaPlan_step"));
const whatsapp_settingsList_1 = __importDefault(require("./pl/whatsapp_settingsList"));
const whatsapp_settingsForm_1 = __importDefault(require("./pl/whatsapp_settingsForm"));
const whatsapp_settings_1 = __importDefault(require("./pl/whatsapp_settings"));
const whatsapp_tabs_1 = __importDefault(require("./pl/whatsapp_tabs"));
const whatsapp_threads_1 = __importDefault(require("./pl/whatsapp_threads"));
const whatsapp_trackLog_1 = __importDefault(require("./pl/whatsapp_trackLog"));
const whatsapp_email_1 = __importDefault(require("./pl/whatsapp_email"));
const whatsapp_groups_1 = __importDefault(require("./pl/whatsapp_groups"));
const whatsapp_commsType_1 = __importDefault(require("./pl/whatsapp_commsType"));
const whatsapp_sourceType_1 = __importDefault(require("./pl/whatsapp_sourceType"));
const whatsapp_dm_1 = __importDefault(require("./pl/whatsapp_dm"));
const activities_panel_1 = __importDefault(require("./pl/activities_panel"));
const whatsapp_groupForm_1 = __importDefault(require("./pl/whatsapp_groupForm"));
const whatsapp_dashboard_1 = __importDefault(require("./pl/whatsapp_dashboard"));
const route_whatsapp_1 = __importDefault(require("./pl/route_whatsapp"));
const whatsapp_directMessages_1 = __importDefault(require("./pl/whatsapp_directMessages"));
const tutorial_1 = __importDefault(require("./pl/tutorial"));
exports.default = {
    ...onboarding_tooltip_1.default,
    ...knowledge_picker_1.default,
    ...app_page_1.default,
    ...app_intext_1.default,
    ...modal_share_1.default,
    ...modal_settings_1.default,
    ...chat_entry_1.default,
    ...user_form_1.default,
    ...slot_goal_1.default,
    ...slot_target_1.default,
    ...slot_format_1.default,
    ...slotData_create_1.default,
    ...slotData_load_1.default,
    ...slotData_form_1.default,
    ...slotData_type_1.default,
    ...app_pagination_1.default,
    ...payment_validation_1.default,
    ...payment_status_1.default,
    ...payment_stripe_1.default,
    ...payment_provider_1.default,
    ...payment_confirmed_1.default,
    ...route_payment_1.default,
    ...payment_search_1.default,
    ...payment_preview_1.default,
    ...user_roles_1.default,
    ...user_grade_1.default,
    ...company_preview_1.default,
    ...company_tooltips_1.default,
    ...company_form_1.default,
    ...access_status_1.default,
    ...access_list_1.default,
    ...avatar_processing_1.default,
    ...avatar_form_1.default,
    ...webhook_eventTypes_1.default,
    ...webhook_cronIntervals_1.default,
    ...tools_webSearch_1.default,
    ...tools_imgGen_1.default,
    ...tools_convoTags_1.default,
    ...tools_galleryTags_1.default,
    ...tools_detectContactData_1.default,
    ...tools_detectTasks_1.default,
    ...tools_productCompare_1.default,
    ...tools_askForVoucher_1.default,
    ...tools_offerCreator_1.default,
    ...tools_quickOffer_1.default,
    ...tools_sendContactForm_1.default,
    ...tools_apiTool_1.default,
    ...tools_productAPISearch_1.default,
    ...tools_dynamicListings_1.default,
    ...tools_personalData_1.default,
    ...tools_rag_1.default,
    ...tools_aiFormAnalyzer_1.default,
    ...tools_communications_search_1.default,
    ...tools_productCard_1.default,
    ...avatar_common_1.default,
    ...avatar_active_1.default,
    ...avatar_tooltips_1.default,
    ...avatar_knowledge_1.default,
    ...avatar_preview_1.default,
    ...style_form_1.default,
    ...botTest_preview_1.default,
    ...botTest_testResults_1.default,
    ...accountGrade_list_1.default,
    ...accountGrade_form_1.default,
    ...limits_avatar_1.default,
    ...limits_user_1.default,
    ...limits_project_1.default,
    ...limits_knowledge_1.default,
    ...limits_customModel_1.default,
    ...limits_writingStyles_1.default,
    ...limits_advanced_prompts_1.default,
    ...limits_prompt_assist_1.default,
    ...limits_anti_hallucination_1.default,
    ...limits_advanced_reports_1.default,
    ...limits_chat_thread_sharing_1.default,
    ...limits_custom_branding_1.default,
    ...limits_widgets_1.default,
    ...limits_voice_agent_1.default,
    ...limits_upgrade_1.default,
    ...voice_chat_error_1.default,
    ...email_pass_reset_1.default,
    ...email_activation_1.default,
    ...email_upgrade_1.default,
    ...email_payment_1.default,
    ...register_complete_1.default,
    ...password_reset_1.default,
    ...accountGrade_preview_1.default,
    ...account_upgrade_1.default,
    ...account_grades_1.default,
    ...userGroup_form_1.default,
    ...userGroup_error_1.default,
    ...user_profile_1.default,
    ...table_controls_1.default,
    ...route_settings_1.default,
    ...route_style_1.default,
    ...route_company_1.default,
    ...route_user_1.default,
    ...route_accountGrade_1.default,
    ...route_userGroup_1.default,
    ...route_user_group_1.default,
    ...route_branch_1.default,
    ...route_profession_1.default,
    ...route_avatar_1.default,
    ...route_conversation_1.default,
    ...route_botTest_1.default,
    ...route_tutorial_1.default,
    ...tutorial_start_1.default,
    ...tutorial_new_section_1.default,
    ...tutorial_create_1.default,
    ...tutorial_edit_1.default,
    ...tutorial_preview_1.default,
    ...tutorial_delete_1.default,
    ...tutorial_list_1.default,
    ...tutorial_search_1.default,
    ...tutorial_form_1.default,
    ...tutorial_errors_1.default,
    ...tutorial_validation_1.default,
    ...tutorial_todos_1.default,
    ...tutorial_statistics_1.default,
    ...botTest_create_1.default,
    ...botTest_edit_1.default,
    ...botTest_tester_1.default,
    ...botTest_target_1.default,
    ...botTest_list_1.default,
    ...botTest_actions_1.default,
    ...route_ai_1.default,
    ...ai_models_1.default,
    ...ai_com_1.default,
    ...ai_fields_1.default,
    ...ai_controls_1.default,
    ...ai_assist_suggestions_1.default,
    ...ai_suggestions_1.default,
    ...ai_assist_1.default,
    ...conversation_type_1.default,
    ...conversation_agent_1.default,
    ...conversation_session_1.default,
    ...conversation_avatar_1.default,
    ...conversation_voice_1.default,
    ...conversation_clear_1.default,
    ...conversation_auto_1.default,
    ...conversation_start_1.default,
    ...conversation_stop_1.default,
    ...conversation_recording_1.default,
    ...conversation_user_1.default,
    ...conversation_processing_1.default,
    ...recording_start_1.default,
    ...recording_process_1.default,
    ...conversation_end_1.default,
    ...message_send_1.default,
    ...microphone_access_1.default,
    ...conversation_interruption_1.default,
    ...conversations_search_1.default,
    ...conversations_date_1.default,
    ...conversations_error_1.default,
    ...conversations_delete_1.default,
    ...conversations_favorite_1.default,
    ...conversations_tooltips_1.default,
    ...route_knowledge_1.default,
    ...route_knowledgeProject_1.default,
    ...knowledge_ragStatus_1.default,
    ...knowledge_statusInfo_1.default,
    ...knowledge_title_1.default,
    ...knowledge_description_1.default,
    ...knowledge_content_1.default,
    ...knowledge_tags_1.default,
    ...knowledge_active_1.default,
    ...knowledge_filter_1.default,
    ...knowledge_project_1.default,
    ...project_form_1.default,
    ...project_name_1.default,
    ...project_description_1.default,
    ...project_icon_1.default,
    ...knowledge_native_1.default,
    ...knowledge_form_1.default,
    ...knowledge_bulk_upload_1.default,
    ...knowledge_preview_1.default,
    ...knowledgeProject_form_1.default,
    ...knowledgeProject_name_1.default,
    ...knowledgeProject_description_1.default,
    ...knowledgeProject_icon_1.default,
    ...chat_teaser_1.default,
    ...chat_heading_1.default,
    ...chat_config_1.default,
    ...chat_noCredits_1.default,
    ...file_upload_1.default,
    ...file_clipboard_1.default,
    ...trainer_reset_1.default,
    ...trainer_tab_1.default,
    ...trainer_upload_1.default,
    ...trainer_config_1.default,
    ...trainer_progress_1.default,
    ...trainer_results_1.default,
    ...trainer_instructions_1.default,
    ...chat_sync_1.default,
    ...ai_chat_1.default,
    ...branch_list_1.default,
    ...branch_create_1.default,
    ...branch_edit_1.default,
    ...branch_search_1.default,
    ...branch_delete_1.default,
    ...branch_form_1.default,
    ...profession_list_1.default,
    ...profession_create_1.default,
    ...profession_edit_1.default,
    ...profession_search_1.default,
    ...profession_delete_1.default,
    ...profession_form_1.default,
    ...profession_common_1.default,
    ...step_shared_1.default,
    ...step_list_1.default,
    ...step_create_1.default,
    ...step_edit_1.default,
    ...step_search_1.default,
    ...step_delete_1.default,
    ...step_form_1.default,
    ...question_list_1.default,
    ...question_create_1.default,
    ...question_edit_1.default,
    ...question_search_1.default,
    ...question_delete_1.default,
    ...question_form_1.default,
    ...question_type_1.default,
    ...onboarding_intro_1.default,
    ...onboarding_list_1.default,
    ...onboarding_create_1.default,
    ...onboarding_edit_1.default,
    ...onboarding_search_1.default,
    ...onboarding_delete_1.default,
    ...onboarding_status_1.default,
    ...onboarding_wizard_1.default,
    ...onboarding_benefits_1.default,
    ...onboarding_button_1.default,
    ...onboarding_image_1.default,
    ...onboarding_faq_1.default,
    ...onboarding_setup_1.default,
    ...onboarding_knowledge_1.default,
    ...onboarding_avatar_1.default,
    ...onboarding_profession_1.default,
    ...voices_david_1.default,
    ...voices_bradford_1.default,
    ...voices_clyde_1.default,
    ...voices_natalie_1.default,
    ...voices_jane_1.default,
    ...voices_magdalena_1.default,
    ...onboarding_records_1.default,
    ...onboarding_record_1.default,
    ...onboarding_warning_1.default,
    ...onboarding_step_1.default,
    ...onboarding_questions_1.default,
    ...onboarding_pagination_1.default,
    ...onboarding_progress_1.default,
    ...onboarding_stats_1.default,
    ...onboarding_view_1.default,
    ...onboarding_pick_1.default,
    ...onboarding_error_1.default,
    ...onboarding_success_1.default,
    ...onboarding_notify_1.default,
    ...login_username_1.default,
    ...login_password_1.default,
    ...login_form_1.default,
    ...register_name_1.default,
    ...register_username_1.default,
    ...register_email_1.default,
    ...register_password_1.default,
    ...register_repeat_password_1.default,
    ...register_form_1.default,
    ...register_company_1.default,
    ...activate_hero_1.default,
    ...activate_page_1.default,
    ...activate_loading_1.default,
    ...activate_success_1.default,
    ...activate_error_1.default,
    ...activate_button_1.default,
    ...settings_general_1.default,
    ...settings_socialMedia_1.default,
    ...settings_status_1.default,
    ...settings_rag_1.default,
    ...settings_credit_1.default,
    ...rag_file_1.default,
    ...settings_googleDrive_1.default,
    ...googleDrive_picker_1.default,
    ...route_reports_1.default,
    ...reports_access_1.default,
    ...reports_costReports_1.default,
    ...reports_export_1.default,
    ...reports_period_1.default,
    ...cost_preview_1.default,
    ...chat_settings_1.default,
    ...config_tooltips_1.default,
    ...share_conversation_1.default,
    ...autocomplete_triggers_1.default,
    ...reports_shared_1.default,
    ...acl_table_1.default,
    ...shortcuts_button_1.default,
    ...shortcuts_table_1.default,
    ...shortcuts_knowledge_1.default,
    ...shortcuts_new_1.default,
    ...shortcuts_settings_1.default,
    ...shortcuts_find_1.default,
    ...shortcuts_prompt_1.default,
    ...currency_error_1.default,
    ...nav_avatar_1.default,
    ...nav_model_1.default,
    ...nav_ai_1.default,
    ...googleDrive_directoryPicker_1.default,
    ...knowledge_bulkUpload_1.default,
    ...rag_settings_1.default,
    ...dblogs_filter_1.default,
    ...dblogs_results_1.default,
    ...dblogs_col_1.default,
    ...dblogs_error_1.default,
    ...dblogs_search_1.default,
    ...dblogs_page_1.default,
    ...route_dblogs_1.default,
    ...db_operation_1.default,
    ...socialMediaPlan_wip_1.default,
    ...socialMediaPlan_nav_1.default,
    ...socialMediaPlan_dashboard_1.default,
    ...socialMediaPlan_stat_1.default,
    ...socialMediaPlan_tab_1.default,
    ...socialMediaPlan_history_1.default,
    ...socialMediaPlan_library_1.default,
    ...socialMediaPlan_filter_1.default,
    ...socialMediaPlan_drawer_1.default,
    ...socialMediaPlan_post_1.default,
    ...socialMediaPlan_approvalQueue_1.default,
    ...socialMediaPlan_ai_1.default,
    ...socialMediaPlan_channels_1.default,
    ...socialMediaPlan_analytics_1.default,
    ...socialMediaPlan_creator_1.default,
    ...socialMediaPlan_platformNotConnected_1.default,
    ...socialMediaPlan_brief_1.default,
    ...socialMediaPlan_schedule_1.default,
    ...socialMediaPlan_step_1.default,
    ...whatsapp_settingsList_1.default,
    ...whatsapp_settingsForm_1.default,
    ...whatsapp_settings_1.default,
    ...whatsapp_tabs_1.default,
    ...whatsapp_threads_1.default,
    ...whatsapp_trackLog_1.default,
    ...whatsapp_email_1.default,
    ...whatsapp_groups_1.default,
    ...whatsapp_commsType_1.default,
    ...whatsapp_sourceType_1.default,
    ...whatsapp_dm_1.default,
    ...activities_panel_1.default,
    ...whatsapp_groupForm_1.default,
    ...whatsapp_dashboard_1.default,
    ...route_whatsapp_1.default,
    ...whatsapp_directMessages_1.default,
    ...pl_2.default,
    ...tutorial_1.default,
    'app.name': "IntHub",
    'acl_resource.knowledge_group': 'Grupa Wiedzy',
    'acl_resource.payment': 'Płatność',
    'acl_resource.botTest': 'Test Bota',
    'app.removed': 'Usunięty',
    'app.share': 'Udostępnij',
    'app.share_link': 'Udostępnij link',
    'app.co_share': 'Współdziel z użytkownikami',
    // Modal headers
    // Chat
    'profile': 'Profil',
    'messages': 'Wiadomości',
    'logout': 'Wyloguj się',
    'lang.en': 'Angielski',
    'lang.de': 'Niemiecki',
    'lang.es': 'Hiszpański',
    'lang.it': 'Włoski',
    'lang.pl': 'Polski',
    'lang.zh': 'Chiński',
    // User form language fields
    // Opcje slotów
    'slot.none': 'Brak',
    // Slot placeholders
    'slot.prompt_context': 'Temat',
    'slot.conversation_goal': 'Cel rozmowy',
    'slot.conversation_target': 'Grupa docelowa',
    'slot.conversation_format': 'Format wyjściowy',
    // Slot data management
    'slot-data.created': 'Dane slotu zostały utworzone pomyślnie',
    'slot-data.deleted': 'Dane slotu zostały usunięte pomyślnie',
    'pagination.itemsPerPage': 'Elementów na stronę',
    'pagination.ellipsis': '…',
    'search.placeholder': 'Szukaj...',
    'search.clear': 'Wyczyść wyszukiwanie',
    'crud.create': 'Utwórz',
    'crud.cancel': 'Anuluj',
    'crud.edit': 'Edytuj',
    'crud.delete': 'Usuń',
    'crud.preview': 'Podgląd',
    'crud.saving': 'Zapisywanie...',
    'crud.filtering': 'Filtrowanie',
    'crud.searchPlaceholder': 'Szukaj...',
    'crud.noCompanies': 'Nie znaleziono firm',
    'crud.noEntries': 'Nie znaleziono wpisów',
    'crud.failedToLoad': 'Nie udało się załadować danych',
    'crud.confirmDelete': 'Czy na pewno chcesz usunąć',
    'crud.deletedSuccessfully': 'Pomyślnie usunięto',
    'crud.failedToDelete': 'Nie udało się usunąć',
    'crud.cantEditItem': 'Ten element nie może być edytowany',
    'crud.cantDeleteItem': 'Ten element nie może być usunięty',
    // Form operations
    'form.back': 'Wstecz',
    // Common status terms
    'common.yes': 'Tak',
    'common.no': 'Nie',
    'common.active': 'Aktywny',
    'common.inactive': 'Nieaktywny',
    'common.common': 'Wspólny',
    'common.free': 'Darmowy',
    'common.unlimited': 'Nieograniczony',
    'common.ordering': 'Kolejność',
    'common.createdAt': 'Utworzono',
    // Payment
    'payment.gateway': 'Bramka Płatności',
    'payment.provider': 'Dostawca Płatności',
    'payment.amount': 'Kwota',
    'payment.description': 'Opis',
    'payment.sessionId': 'ID Sesji',
    'payment.id': 'ID Płatności',
    'payment.status': 'Status Płatności',
    'payment.currentStatus': 'Aktualny Status',
    'payment.initiate': 'Rozpocznij Płatność',
    'payment.testConnection': 'Testuj Połączenie',
    'payment.refreshStatus': 'Odśwież Status',
    'payment.reset': 'Resetuj Płatność',
    'payment.defaultDescription': 'Transakcja płatności',
    'payment.initialized': 'Płatność została pomyślnie zainicjowana',
    'payment.initializationFailed': 'Inicjalizacja płatności nie powiodła się',
    'payment.successful': 'Płatność zakończona pomyślnie',
    'payment.pending': 'Płatność oczekuje',
    'payment.rejected': 'Płatność została odrzucona',
    'payment.error': 'Wystąpił błąd płatności',
    'payment.connectionSuccessful': 'Połączenie z dostawcą płatności pomyślne',
    'payment.connectionFailed': 'Połączenie z dostawcą płatności nie powiodło się',
    'payment.statusCheckFailed': 'Nie udało się sprawdzić statusu płatności',
    'payment.noPaymentId': 'Brak dostępnego ID płatności',
    'payment.processing': 'Przetwarzanie...',
    'payment.confirmationFailed': 'Potwierdzenie płatności nie powiodło się',
    'payment.unsupportedProvider': 'Nieobsługiwany dostawca płatności',
    'payment.selectProvider': 'Wybierz Dostawcę Płatności',
    'payment.operationName': 'Operacja Płatnicza',
    // Payment List & Preview
    'payment.user': 'Użytkownik',
    'payment.email': 'Email',
    'payment.targetGrade': 'Docelowy Stopień',
    'payment.paidAt': 'Zapłacono',
    'payment.failureReason': 'Przyczyna Niepowodzenia',
    'payment.details': 'Szczegóły Płatności',
    'payment.timeline': 'Oś Czasu',
    'payment.created': 'Utworzono',
    'payment.updated': 'Zaktualizowano',
    'payment.technicalDetails': 'Szczegóły Techniczne',
    'payment.stripePaymentIntentId': 'ID Intencji Płatności Stripe',
    'payment.stripeCustomerId': 'ID Klienta Stripe',
    'payment.orderId': 'ID Zamówienia',
    'payment.metadata': 'Metadane',
    // Gender
    'gender.male': 'Mężczyzna',
    'gender.female': 'Kobieta',
    'searchUser.users': 'Użytkownicy',
    'searchUser.searchPlaceholder': 'Szukaj użytkowników...',
    'searchUser.selectedParticipants': 'Wybrani uczestnicy',
    'searchUser.availableUsers': 'Dostępni użytkownicy',
    'searchUser.noUsersFound': 'Nie znaleziono użytkowników pasujących do wyszukiwania.',
    'searchUser.failedToLoadUsers': 'Nie udało się załadować użytkowników',
    // Kolumny listy użytkowników
    'user.name': 'Imię',
    'user.last_name': 'Nazwisko',
    'user.username': 'Nazwa użytkownika',
    'user.email': 'Email',
    'user.parent': 'Użytkownik nadrzędny',
    'user.role': 'Rola',
    'user.status': 'Status',
    'user.company': 'Firma',
    // User list component (for non-admin users)
    'userList.title': 'Członkowie Zespołu',
    'userList.description': 'Połącz się i współpracuj z członkami swojego zespołu',
    'userList.searchPlaceholder': 'Szukaj członków zespołu...',
    'userList.noUsers': 'Nie znaleziono członków zespołu',
    'userList.loading': 'Ładowanie członków zespołu...',
    'userList.online': 'Online',
    'userList.offline': 'Offline',
    'userList.lastSeen': 'Ostatnio widziany',
    'userList.startChat': 'Rozpocznij Chat',
    'userList.viewProfile': 'Zobacz Profil',
    // Kolumny listy firm
    'company.name': 'Nazwa',
    'company.nip': 'NIP',
    'company.email': 'Email',
    'company.phone': 'Telefon',
    'company.city': 'Miasto',
    'company.address': 'Adres',
    'company.street': 'Ulica',
    'company.postalCode': 'Kod Pocztowy',
    'company.website': 'Strona WWW',
    'company.description': 'Opis',
    'company.modules': 'Moduły',
    'company.active': 'Aktywna',
    // Company Preview & Tooltips
    // Company form
    // Kolumny ustawień dostępu
    'access.user_or_company': 'Użytkownik / Firma',
    'access.user_group': 'Grupa Użytkowników',
    'access.policies': 'Polityki dostępu',
    'access.active': 'Aktywny',
    // Kolumny listy avatarów
    'avatar.image': 'Obraz',
    'avatar.name': 'Imię',
    'avatar.gender': 'Płeć',
    'avatar.age': 'Wiek',
    'avatar.model': 'Model',
    'avatar.onboarded': 'Wdrożony',
    'avatar.processing': 'Przetwarzanie',
    'avatar.avatar': 'Awatar',
    'avatar.description': 'Opis',
    // Strona listy avatarów
    'avatar.listTitle': 'Asystenci',
    'avatar.noAvatars': 'Nie znaleziono asystentów',
    'avatar.addAvatar': 'Dodaj Asystenta',
    'avatar.searchPlaceholder': 'Szukaj asystenta...',
    'avatar.listView': 'Widok Listy',
    'avatar.gridView': 'Widok Siatki',
    // Avatar form knowledge section
    // Avatar form page
    // Konfiguracja webhooków
    // Definicje webhooków
    // Przykłady ładunków webhook
    // Typy zdarzeń webhooków
    // Akcje wiedzy
    'knowledge.edit': 'Edycja wiedzy',
    // Interwały cron webhooków
    // Lexicon configuration
    // Narzędzia API
    'apiTool.requestSent': 'Zapytanie wysłane',
    'apiTool.requestFailed': 'Zapytanie nieudane',
    'apiTool.collectingData': 'Zbieranie danych...',
    'apiTool.response': 'Odpowiedź',
    'apiTool.noData': 'Brak danych zapytania API',
    'tools.productCard': 'Karty Produktów',
    'avatar.creator': 'Twórca',
    'avatar.voiceAgent': 'Agent Głosowy',
    'avatar.common': 'Wspólny Awatar',
    'avatar.active': 'Aktywny',
    'avatar.cantEditCommon': 'Nie można edytować wspólnych awatarów. Tylko super administratorzy mogą edytować wspólne awatary.',
    'avatar.cantDeleteCommon': 'Nie można usuwać wspólnych awatarów. Tylko super administratorzy mogą usuwać wspólne awatary.',
    // Avatar tooltips
    // Avatar knowledge management
    // Avatar preview page
    // Style List Columns
    'style.name': 'Nazwa',
    'style.description': 'Opis',
    'style.prompt': 'Prompt',
    'style.common': 'Wspólny Styl',
    'style.active': 'Aktywny',
    'style.style': 'Styl',
    // Style list page
    'style.listTitle': 'Style Pisania',
    'style.addStyle': 'Dodaj Styl Pisania',
    'style.searchPlaceholder': 'Szukaj stylów...',
    // Style form page
    'style.updated': 'zaktualizowano',
    'style.created': 'utworzono',
    'style.update': 'aktualizuj',
    'style.create': 'utwórz',
    // Bot Test
    'botTest.management': 'Zarządzanie Testami Botów',
    'botTest.list': 'Testy Botów',
    'botTest.create': 'Utwórz Test Bota',
    'botTest.edit': 'Edytuj Test Bota',
    'botTest.view': 'Zobacz Test Bota',
    'botTest.add': 'Dodaj Test Bota',
    'botTest.searchPlaceholder': 'Szukaj testów botów...',
    'botTest.details': 'Szczegóły Testu',
    'botTest.name': 'Nazwa Testu',
    'botTest.namePlaceholder': 'Wprowadź nazwę testu',
    'botTest.testDate': 'Data Testu',
    'botTest.description': 'Opis',
    'botTest.descriptionPlaceholder': 'Wprowadź opis testu',
    'botTest.active': 'Aktywny',
    'botTest.inactive': 'Nieaktywny',
    'botTest.status': 'Status',
    'botTest.testersCount': 'Testerzy',
    'botTest.targetsCount': 'Cele',
    'botTest.tester': 'Tester',
    'botTest.testers': 'Testerzy',
    'botTest.targets': 'Cele Testów',
    'botTest.messages': 'wiadomości',
    'botTest.noTesters': 'Brak dostępnych testerów do uruchomienia',
    'botTest.addTarget': 'Dodaj Cel',
    'botTest.noTargets': 'Brak zdefiniowanych celów',
    'botTest.selectAvatar': 'Wybierz Awatar',
    'botTest.overrideTesterPrompt': 'Nadpisz Prompt Testera',
    'botTest.testerPromptOverride': 'Niestandardowy Prompt',
    'botTest.showAdvancedTools': 'Zaawansowane Narzędzia',
    'botTest.advancedToolsData': 'Dane Zaawansowanych Narzędzi (JSON)',
    'botTest.advancedToolsDataPlaceholder': 'Wprowadź konfigurację narzędzi jako JSON...',
    'botTest.addJsonData': 'Dodaj dane JSON',
    'botTest.editJsonData': 'Edytuj dane JSON',
    'botTest.jsonDataSet': 'JSON ustawiony',
    'botTest.messagesCount': 'Liczba Wiadomości',
    'botTest.testerName': 'Nazwa Testera',
    'botTest.temperature': 'Temperatura',
    'botTest.prompt': 'Prompt',
    'botTest.defaultTesterName': 'Domyślny Tester',
    'botTest.testerNamePlaceholder': 'Wprowadź nazwę testera...',
    'botTest.promptPlaceholder': 'Wprowadź prompt testu...',
    'botTest.noTestsFound': 'Nie znaleziono testów botów',
    'botTest.noTestsFoundDesc': 'Zacznij od utworzenia swojego pierwszego testu bota, aby porównać różne konfiguracje AI.',
    'botTest.failedToLoad': 'Nie udało się załadować testów botów',
    'botTest.loadFailed': 'Nie udało się załadować testu bota',
    'botTest.saveFailed': 'Nie udało się zapisać testu bota',
    'botTest.deleted': 'Test bota został pomyślnie usunięty',
    'botTest.deleteFailed': 'Nie udało się usunąć testu bota',
    'botTest.created': 'Test bota został pomyślnie utworzony',
    'botTest.updated': 'Test bota został pomyślnie zaktualizowany',
    'botTest.nameRequired': 'Nazwa testu jest wymagana',
    'botTest.testDateRequired': 'Data testu jest wymagana',
    'botTest.minimumOneTester': 'Wymagany jest co najmniej jeden tester',
    'botTest.noActiveTester': 'Nie wybrano aktywnego testera',
    'botTest.testerNameRequired': 'Nazwa testera jest wymagana',
    'botTest.testerPromptRequired': 'Prompt testera jest wymagany',
    'botTest.targetAvatarRequired': 'Awatar docelowy jest wymagany',
    'botTest.noAvatarsAvailable': 'Brak dostępnych awatarów do testowania',
    'botTest.configuration': 'Konfiguracja',
    // Bot Test Preview
    // Bot Test Preview Tabs
    // Bot Test Results
    // Bot Test Results  
    // Pakiety Cenowe List Columns
    'accountGrade.name': 'Nazwa',
    'accountGrade.description': 'Opis',
    'accountGrade.price': 'Cena Miesięczna',
    'accountGrade.yearlyPrice': 'Cena Roczna',
    'accountGrade.creditsPerMonth': 'Kredyty na Miesiąc',
    'accountGrade.advancedPrompts': 'Zaawansowane Prompty',
    'accountGrade.promptAssist': 'Asystent Promptów',
    'accountGrade.maxAvatars': 'Maks. Awatarów',
    'accountGrade.maxUsers': 'Maks. Użytkowników',
    'accountGrade.maxProjectsCount': 'Maks. Projektów',
    'accountGrade.maxKnowledgeEntries': 'Maks. Wiedzy',
    'accountGrade.antiHallucination': 'Anti-Halucynacja',
    'accountGrade.advancedReports': 'Zaawansowane Raporty',
    'accountGrade.chatThreadSharing': 'Udostępnianie Czatów',
    'accountGrade.customBranding': 'Własny Branding',
    'accountGrade.widgets': 'Widżety',
    'accountGrade.customAiModels': 'Własne Modele AI',
    'accountGrade.voiceAgent': 'Agent Głosowy',
    'accountGrade.writingStyles': 'Style Pisania',
    'accountGrade.active': 'Aktywne',
    'accountGrade.order': 'Kolejność',
    // Pakiety Cenowe list page
    'accountGrade.listTitle': 'Pakiety Cenowe',
    'accountGrade.noAccountGrades': 'Nie znaleziono pakietów cenowych',
    'accountGrade.noResults': 'Nie znaleziono pakietów cenowych',
    'accountGrade.addAccountGrade': 'Dodaj Pakiet Cenowy',
    'accountGrade.add': 'Dodaj Pakiet Cenowy',
    'accountGrade.createTitle': 'Utwórz Pakiet Cenowy',
    'accountGrade.searchPlaceholder': 'Szukaj pakietu cenowego...',
    // Pakiety Cenowe form page
    // Pakiety Cenowe sections
    'accountGrade.previewTitle': 'Podgląd Stopnia Konta',
    'accountGrade.basicInfo': 'Podstawowe Informacje',
    // Account limits and restrictions
    'limits.noAccountGrade': 'Nie znaleziono planu konta. Skontaktuj się z obsługą.',
    // Voice chat errors
    // Email translations
    // Account upgrade emails
    // Payment success emails
    // Payment failed emails
    // Common payment fields
    // Registration completion
    // Password Reset Page
    // Password Reset Confirm Page
    'accountGrade.features': 'Funkcje',
    'accountGrade.status': 'Status',
    'accountGrade.limits': 'Limity',
    'accountGrade.unlimited': 'Nieograniczone',
    // Pakiety Cenowe preview page
    // Account upgrade page
    // Pakiety Cenowe features
    // Etykiety formularzy
    'form.label': 'Etykieta',
    'form.value': 'Wartość',
    'form.required': 'Wymagane',
    'form.optional': 'Opcjonalne',
    // Strona logowania
    'login.usernameLabel': 'Login/Email',
    'login.passwordLabel': 'Hasło',
    'login.forgotPassword': 'Zapomniałeś hasła?',
    'login.submit': 'Zaloguj się',
    // Strona rejestracji
    'register.nameLabel': 'Imię',
    'register.lastNameLabel': 'Nazwisko',
    'register.usernameLabel': 'Login',
    'register.emailLabel': 'E-mail',
    'register.passwordLabel': 'Hasło',
    'register.repeatPasswordLabel': 'Powtórz hasło',
    'register.submit': 'Zarejestruj',
    // Strona listy użytkowników
    'user.listTitle': 'Użytkownicy',
    'user.addUser': 'Dodaj użytkownika',
    'user.searchPlaceholder': 'Szukaj użytkowników...',
    // Kolumny listy grup użytkowników
    'userGroup.name': 'Nazwa',
    'userGroup.description': 'Opis',
    'userGroup.active': 'Aktywna',
    'userGroup.owner': 'Właściciel',
    'userGroup.userCount': 'Liczba Użytkowników',
    // Strona listy grup użytkowników
    'userGroup.listTitle': 'Grupy Użytkowników',
    'userGroup.addUserGroup': 'Dodaj Grupę Użytkowników',
    'userGroup.searchPlaceholder': 'Szukaj grup użytkowników...',
    // Strona formularza grup użytkowników
    'userGroup.create': 'Utwórz Grupę Użytkowników',
    // Formularz użytkownika
    // User form preview
    // User form errors
    // User profile
    // Strona demo czatu
    'chatDemo.title': 'Demo systemu czatu',
    'chatDemo.intro': 'Zaimplementowano kompletny system historii rozmów czatowych.',
    'chatDemo.featuresTitle': 'Zaimplementowane funkcje:',
    'chatDemo.openChat': 'Otwórz system czatu',
    'chatDemo.implementationTitle': 'Szczegóły implementacji:',
    'chatDemo.backendModels': 'Modele backendu:',
    'chatDemo.apiEndpoints': 'Endpointy API:',
    'chatDemo.frontendComponents': 'Komponenty frontendowe:',
    // Strona główna
    'home.dashboardArea': 'OBSZAR PANELU',
    // Nazwy tras
    'route.dashboard': 'Pulpit',
    'route.companyManagement': 'Zarządzanie',
    'route.settings': 'Ustawienia',
    'route.register': 'Rejestracja',
    'route.profile': 'Profil',
    'route.assistants': 'Asystenci',
    'route.team': 'Zespół',
    // Trasy ustawień
    // Style routes
    'route.styles': 'Style Pisania',
    // Trasy zarządzania
    // Trasy grup użytkowników
    // Trasy avatarów
    'route.conversations': 'Konwersacje',
    'route.conversationList': 'Konwersacje',
    'route.conversationPreview': 'Podgląd Konwersacji',
    // Todo-related tutorial translations
    'botTest.title': 'Test Bota',
    'botTest.date': 'Data',
    'botTest.addTester': 'Dodaj Testera',
    'botTest.model': 'Model',
    'route.ai': 'AI',
    'ai-assist.header': 'Asystent AI',
    'ai-assist.minimize': 'Minimalizuj',
    'ai-assist.expand': 'Rozwiń',
    'ai-assist.info': 'Asystent AI przeanalizuje Twoje zapytania i rozmowy i dostarczy sugestie, które pomogą uzyskać lepsze rezultaty. Możesz go wyłączyć w ustawieniach czatu w prawym dolnym rogu obszaru wprowadzania tekstu',
    'ai-assist.no-entries': 'Rozpocznij rozmowę, aby aktywować pomoc asystenta AI',
    'modelSelect.instruction': 'Wybierz swojego awatara lub model AI, z którym chcesz rozmawiać',
    'modelSelect.knowledgeCreatingInProgress': 'Tworzenie wpisu bazy wiedzy w toku...',
    // AI Suggestions Component
    // AI Assist Component
    // Model Select Component
    'modelSelect.models': 'Modele',
    'modelSelect.avatars': 'Awatary',
    'modelSelect.liveChats': 'Czaty na Żywo',
    'modelSelect.voiceModels': 'Modele Głosowe',
    // Tłumaczenia konwersacji
    'conversation.demo': 'Agent Głosowy',
    'conversation.agent': 'Agent',
    'conversation.connected': 'Połączony',
    'conversation.disconnected': 'Rozłączony',
    'conversation.connecting': 'Łączenie...',
    'conversation.voice': 'Głos',
    'conversation.you': 'Ty',
    'conversation.send': 'Wyślij',
    'conversation_agent.first_word': 'Cześć! Jak mogę Ci dzisiaj pomóc?',
    'conversation.volume': 'Głośność',
    'conversation.debug': 'Informacje debugowania',
    'conversation.language': 'Język',
    'conversation.messages': 'Wiadomości',
    'conversation.started': 'Konwersacja rozpoczęta pomyślnie!',
    'conversation.ended': 'Konwersacja zakończona.',
    'conversation.error': 'Wystąpił błąd podczas konwersacji.',
    'conversation.start': 'Rozpocznij Konwersację',
    'conversation.end': 'Zakończ Konwersację',
    'recording.start': 'Rozpocznij Nagrywanie',
    'recording.stop': 'Zatrzymaj Nagrywanie',
    'message.used_tools': 'Użyte Narzędzia',
    'conversations.title': 'Konwersacje',
    'conversations.loading': 'Ładowanie konwersacji...',
    'conversations.retry': 'Ponów',
    'conversations.empty': 'Nie znaleziono konwersacji',
    'conversations.chat_history': 'Historia Czatu',
    'conversations.no_conversations_yet': 'Jeszcze brak konwersacji',
    'conversations.no_messages_yet': 'Jeszcze brak wiadomości',
    'conversations.loading_more': 'Ładowanie więcej...',
    'conversations.no_more_conversations': 'Brak kolejnych konwersacji',
    'conversations.new_chat': 'Nowy Wątek',
    'conversations.listTitle': 'Konwersacje',
    'conversations.newConversation': 'Nowa Konwersacja',
    'conversations.search_placeholder': 'Szukaj konwersacji...',
    'conversations.failedToLoad': 'Nie udało się załadować konwersacji',
    'conversations.failedToLoadMessages': 'Nie udało się załadować wiadomości',
    'conversations.last_activity': 'Ostatnia Aktywność',
    'conversations.lastActivity': 'Ostatnia Aktywność',
    'conversations.model': 'Model',
    'conversations.avatar': 'Avatar',
    'conversations.openInChat': 'Otwórz w Czacie',
    'conversations.user': 'Użytkownik',
    'conversations.assistant': 'Asystent',
    'conversations.noMessages': 'Brak wiadomości w tej konwersacji',
    // Wspólne akcje
    'common.create': 'Utwórz',
    'common.update': 'Aktualizuj',
    'common.cancel': 'Anuluj',
    'common.close': 'Zamknij',
    'common.back': 'Wróć',
    'common.clear': 'Wyczyść',
    'common.moveUp': 'Przenieś w górę',
    'common.moveDown': 'Przenieś w dół',
    'common.delete': 'Usuń',
    'common.optional': '(Opcjonalne)',
    'common.none': 'Brak',
    'common.pay': 'Zapłać',
    'common.loading': 'Ładowanie...',
    'common.showing': 'Pokazuję',
    'common.to': 'do',
    'common.of': 'z',
    'common.next': 'Następny',
    'common.previous': 'Poprzedni',
    'common.apply': 'Zastosuj',
    'common.results': 'wyników',
    'common.hide': 'Ukryj',
    // Zarządzanie kontem
    // Poziomy kont
    // Ścieżki wiedzy
    // Tłumaczenia wiedzy
    'knowledge.create': 'Utwórz wiedzę',
    'knowledge.creator': 'Twórca',
    'knowledge.ragStatus': 'Status RAG',
    'knowledge.assigned': 'Przypisane',
    'knowledge.createdAt': 'Data utworzenia',
    'knowledge.reindex': 'Ponownie indeksuj',
    'knowledge.reindexingStarted': 'Ponowne indeksowanie zostało uruchomione',
    'knowledge.title': 'Tytuł',
    'knowledge.description': 'Opis',
    'knowledge.content': 'Treść',
    'knowledge.file': 'Plik',
    'knowledge.tags': 'Tagi',
    'knowledge.project': 'Projekt',
    'knowledge.no_group': 'Bez grupy',
    'knowledge.no_project': 'Bez projektu',
    'knowledge.active': 'Aktywny',
    // Project translations
    'project.manage': 'Zarządzaj projektami',
    'project.none': 'Brak projektu',
    'project.name': 'Nazwa projektu',
    'project.description': 'Opis',
    'project.color': 'Kolor',
    'project.icon': 'Ikona',
    'project.isActive': 'Aktywny',
    'project.preview': 'Podgląd',
    'project.list': 'Projekty',
    'project.create': 'Dodaj projekt',
    'project.edit': 'Edytuj projekt',
    'project.creator': 'Twórca',
    'knowledge.native': 'Wiedza Natywna',
    // Tłumaczenia formularza wiedzy
    // Tłumaczenia masowego przesyłania wiedzy
    // Google Drive bulk upload
    // Google Drive bulk upload info
    // Knowledge preview
    'knowledge.preview': 'Podgląd Wiedzy',
    // Knowledge preview sections
    // Knowledge preview content type labels
    // Knowledge preview RAG status labels
    // Knowledge preview active status
    // Knowledge preview usage
    // Tłumaczenia projektów
    // Project form
    // Project general
    'knowledgeProject.name': 'Nazwa projektu',
    'knowledgeProject.description': 'Opis',
    'knowledgeProject.color': 'Kolor',
    'knowledgeProject.icon': 'Ikona',
    'knowledgeProject.isActive': 'Aktywny',
    'knowledgeProject.preview': 'Podgląd',
    'knowledgeProject.list': 'Projekty',
    'knowledgeProject.create': 'Dodaj projekt',
    // Chat component translations
    'file.ext': 'typ pliku',
    'file.size': 'rozmiar pliku',
    // Wiadomości popup
    'popup.error': 'Błąd',
    'popup.alert': 'Uwaga',
    'popup.confirm': 'Potwierdzenie',
    'popup.ok': 'OK',
    'popup.yes': 'Tak',
    'popup.no': 'Nie',
    // LLM Trainer
    'trainer.title': 'Trainer Modeli LLM',
    "trainer.listTitle": "Lista zadań treningowych",
    "trainer.jobId": "ID Zadania",
    "trainer.modelName": "Nazwa Modelu",
    "trainer.trainingType": "Typ Szkolenia",
    "trainer.status": "Status",
    "trainer.createdAt": "Utworzono",
    "trainer.updatedAt": "Zaktualizowano",
    "trainer.addJob": "Dodaj Zadanie",
    // Komponent Wgrywania
    // Wprowadzanie Manualne
    // PDF Processing
    // Komponent Konfiguracji
    // Komponent Postępu
    // Komponent Wyników
    // Komponent Instrukcji
    "training_jobs.list": "Lista zadań szkoleniowych",
    // CodeViewerComponent translations
    'code-viewer.show_code': 'Pokaż kod',
    'code-viewer.hide_code': 'Ukryj kod',
    'code-viewer.writing_code': 'Pisanie kodu',
    // Branch translations
    'route.branches': 'Branże',
    'branch.name': 'Nazwa',
    'branch.description': 'Opis',
    'branch.color': 'Kolor',
    'branch.create': 'Utwórz Branżę',
    // Branch form page
    'branch.form.error.load_failed': "Błąd podczas ładowania branży",
    'branch.form.error.action_failed': "Akcja nie powiodła się",
    'branch.form.error.general_error': "Wystąpił błąd",
    'branch.form.action.updated': "zaktualizowana",
    'branch.form.action.created': "utworzona",
    'branch.form.action.update': "zaktualizować",
    'branch.form.action.create': "utworzyć",
    'branch.form.success.updated': "Branża zaktualizowana pomyślnie",
    'branch.form.success.created': "Branża utworzona pomyślnie",
    'branch.form.success.action_completed': "Akcja zakończona",
    // Profession translations
    'route.professions': 'Zawody',
    'profession.name': 'Nazwa',
    'profession.description': 'Opis',
    'profession.branch': 'Branża',
    'profession.create': 'Utwórz Zawód',
    'profession.common': 'Wspólny',
    'profession.creator': 'Twórca',
    // Step translations
    'route.steps': 'Kroki',
    'step.title': 'Tytuł',
    'step.description': 'Opis',
    'step.order': 'Kolejność',
    'step.isShared': 'Udostępniony',
    'step.profession': 'Zawód',
    'step.create': 'Utwórz Krok',
    // Step form page
    // Question translations
    'route.questions': 'Pytania',
    'question.title': 'Tytuł',
    'question.description': 'Opis',
    'question.type': 'Typ',
    'question.required': 'Wymagane',
    'question.order': 'Kolejność',
    'question.step': 'Krok',
    'question.create': 'Utwórz Pytanie',
    // Question form (question manager)
    // Question types
    // Onboarding translations
    'route.onboardings': 'Onboarding',
    // Onboarding intro
    'onboarding.avatar': 'Avatar',
    'onboarding.profession': 'Zawód',
    'onboarding.status': 'Status',
    'onboarding.currentStep': 'Bieżący Krok',
    'onboarding.createdAt': 'Utworzono',
    'onboarding.create': 'Rozpocznij Onboarding',
    // Onboarding Wizard translations
    // Onboarding Component
    'onboarding.title': 'Onboarding',
    'onboarding.loading': 'Ładowanie...',
    // AI Onboarding page content
    // FAQ Section
    // Voice descriptions
    // Onboarding Records (for user-list component)
    'knowledge': 'wiedza',
    // Additional onboarding translations
    'onboarding.filter': 'Filtruj',
    'onboarding.progress': 'Postęp',
    'onboarding.createdBy': 'Utworzone przez',
    'pagination.previous': 'Poprzedni',
    'pagination.next': 'Następny',
    'actions': 'Akcje',
    'view': 'Zobacz',
    'edit': 'Edytuj',
    'delete': 'Usuń',
    'loading': 'Ładowanie...',
    // Onboarding view page
    // Onboarding pick page
    // Onboarding errors
    // Onboarding success messages
    // Additional onboarding fields
    'onboarding.fields_completed': 'pola wypełnione',
    // Missing login/register keys not in main section
    // Registration Complete page    
    // Account Activation page
    // Settings translations
    'settings.saveButton': 'Zapisz Ustawienia',
    'settings.savedSuccessfully': 'Ustawienia zapisane pomyślnie',
    'settings.failedToSave': 'Błąd przy zapisywaniu ustawień',
    'settings.failedToLoad': 'Błąd ładowania ustawień',
    // Settings Tabs
    'socialMediaPlan.brief.ctaPlaceholder': "Wprowadź wezwanie do działania...",
    "settings.socialMedia.dictionary.type.audience": "Grupa docelowa",
    // General Settings - Chat Learning
    // RAG Settings
    // Credit Settings
    // RAG File Operations
    // RAG Indexing Settings
    // RAG Search Settings
    // Google Drive Settings
    // Google Drive File Picker
    // Status indicators
    // Google Drive Status
    // Setup Instructions
    // How it works
    // Connected state
    // Resource translations
    'resource.active': 'Aktywny',
    // Generated Image Component
    'gen-image.noData': 'Nie podano danych obrazu',
    'gen-image.invalidData': 'Nieprawidłowy format danych obrazu',
    'gen-image.loadError': 'Błąd podczas ładowania obrazu',
    'gen-image.loading': 'Ładowanie obrazu...',
    'gen-image.altText': 'Wygenerowany obraz',
    'gen-image.download': 'Pobierz',
    'gen-image.copyToClipboard': 'Skopiuj do schowka',
    // File Card Component
    'file-card.errorLoading': 'Błąd podczas ładowania pliku',
    'file-card.unknownFile': 'Nieznany plik',
    'file-card.unknownSize': 'Nieznany rozmiar',
    'file-card.download': 'Pobierz',
    'file-card.addToKdb': 'Dodaj do Bazy Wiedzy',
    'file-card.videoNotSupported': 'Twoja przeglądarka nie obsługuje tagu wideo.',
    'file-card.zoomHint': 'kliknij, aby powiększyć',
    'file-card.zoom': 'Powiększ',
    'file-card.close': 'Zamknij',
    // Reports routes
    // Reports and Cost Analytics
    'reports.totalCost': 'Całkowity Koszt',
    'reports.totalMessages': 'Całkowita Liczba Wiadomości',
    'reports.avgCostPerMessage': 'Średni Koszt/Wiadomość',
    'reports.totalTokens': 'Całkowita Liczba Tokenów',
    'reports.filters': 'Filtry',
    'reports.startDate': 'Data Początkowa',
    'reports.endDate': 'Data Końcowa',
    'reports.minCost': 'Minimalny Koszt',
    'reports.maxCost': 'Maksymalny Koszt',
    'reports.userName': 'Nazwa Użytkownika',
    'reports.companyName': 'Nazwa Firmy',
    'reports.userNamePlaceholder': 'Filtruj według nazwy użytkownika...',
    'reports.companyNamePlaceholder': 'Filtruj według nazwy firmy...',
    'reports.avatarNamePlaceholder': 'Filtruj według nazwy awatara...',
    'reports.date': 'Data',
    'reports.promptTokens': 'Tokeny Promptu',
    'reports.completionTokens': 'Tokeny Odpowiedzi',
    'reports.cost': 'Koszt',
    'reports.cost_type': 'Rodzaj zapytania',
    'reports.company': 'Firma',
    'reports.upstreamCost': 'Koszt Upstream',
    'reports.reasoningTokens': 'Tokeny Rozumowania',
    'reports.cachedTokens': 'Tokeny w Cache',
    'reports.noData': 'Brak dostępnych danych o kosztach',
    'reports.noDataDescription': 'Nie znaleziono danych o kosztach użycia dla wybranych kryteriów.',
    'reports.failedToLoad': 'Błąd ładowania danych o kosztach',
    'reports.loadingError': 'Błąd ładowania danych o kosztach',
    'reports.user': 'Użytkownik',
    'reports.costTrends': 'Trendy Kosztów i Tokenów',
    'reports.showChart': 'Pokaż Wykres',
    'reports.tokens': 'Tokeny',
    'report.usage_cost_data': 'Dane Kosztów Użycia',
    'reports.userSummary': 'Statystyki Podsumowania Użytkowników',
    'reports.messageCount': 'Wiadomości',
    'reports.avatarUsage': 'Statystyki Użycia Awatara',
    'reports.avgTokensPerMessage': 'Średnie Tokeny/Wiadomość',
    'reports.firstUsage': 'Pierwsze Użycie',
    'reports.lastUsage': 'Ostatnie Użycie',
    // Cost Preview
    // Chat Settings
    // Chat Config
    // Config Tooltips
    // Knowledge Database Tooltips
    'kdb.fullscan_tooltip': 'Pełne skanowanie dokumentu umieści cały plik w prompcie, co spowoduje droższe i dłuższe odpowiedzi',
    // Share Conversation
    // Icon Picker
    'iconPicker.selectIcon': 'Wybierz ikonę',
    'iconPicker.clear': 'Wyczyść wybór',
    'iconPicker.searchPlaceholder': 'Szukaj ikon...',
    'iconPicker.noResults': 'Nie znaleziono ikon',
    'iconPicker.resultsLimited': 'Wyniki ograniczone do 100 ikon. Użyj wyszukiwania, aby zawęzić wybór.',
    // AI Assistant Context
    'context.userMessages': 'wiadomości użytkownika',
    'context.assistantMessages': 'wiadomości asystenta',
    'context.activeEntries': 'aktywne wpisy',
    'context.summary': 'Kontekst',
    'context.empty': 'Brak dostępnego kontekstu',
    'context.validationError': 'Błąd walidacji kontekstu',
    // Autocomplete Triggers Component
    // Raporty
    'and': 'i',
    // ACL Table
    // ACL Resource Descriptions
    'acl_resource_desc.company': 'Zarządzanie ustawieniami i informacjami firmy',
    'acl_resource_desc.user': 'Zarządzanie kontami użytkowników i profilami',
    'acl_resource_desc.user_group': 'Zarządzanie grupami użytkowników i ich uprawnieniami',
    'acl_resource_desc.settings_general': 'Dostęp do ogólnych ustawień aplikacji',
    'acl_resource_desc.settings_access': 'Zarządzanie kontrolą dostępu i ustawieniami bezpieczeństwa',
    'acl_resource_desc.settings_styles': 'Zarządzanie stylami pisania i szablonami',
    'acl_resource_desc.avatar': 'Tworzenie i zarządzanie awatarami AI i asystentami',
    'acl_resource_desc.ai': 'Dostęp do modeli AI i konfiguracji',
    'acl_resource_desc.knowledge': 'Zarządzanie bazą wiedzy i zasobami informacyjnymi',
    'acl_resource_desc.project': 'Tworzenie i zarządzanie projektami i przepływami pracy',
    'acl_resource_desc.onboarding': 'Zarządzanie procesami wdrażania użytkowników i szablonami',
    'acl_resource_desc.reports': 'Generowanie i przeglądanie raportów systemowych i analiz',
    // ACL Action Descriptions
    'acl_action_desc.read': 'Przeglądanie i dostęp do informacji bez wprowadzania zmian',
    'acl_action_desc.write': 'Tworzenie, edytowanie i modyfikowanie treści oraz ustawień',
    'acl_action_desc.delete': 'Usuwanie i trwałe kasowanie elementów z systemu',
    // V-Select Component
    'v-select.createNew': 'Utwórz nowy',
    'v-select.noOptions': 'Brak dostępnych opcji',
    // Keyboard shortcuts
    'shortcuts.title': 'Skróty Klawiszowe',
    'shortcuts.tooltip-text': 'Zobacz dostępne skróty klawiszowe',
    // Password Reset
    // Password Reset Confirm
    // Routes
    'route.passwordReset': 'Resetowanie Hasła',
    'route.passwordResetConfirm': 'Resetuj Hasło',
    'route.registerComplete': 'Rejestracja zakończona',
    'route.activateAccount': 'Aktywacja konta',
    // Currency
    // Navigation
    'nav.credits': 'Kredyty',
    // Tools
    'tools.toolLabel': 'Narzędzie',
    'tools.activeTools': 'Aktywne Narzędzia',
    'tools.expandAll': 'Rozwiń Wszystkie',
    'tools.collapseAll': 'Zwiń Wszystkie',
    'tools.unknownTool': 'Nieznane narzędzie',
    'tools.noActiveTools': 'Brak aktywnych narzędzi',
    'tools.webSearch': 'Wyszukiwanie Web',
    'tools.rag': 'Baza Wiedzy',
    'webSearch.searching': 'Wyszukiwanie w sieci',
    'webSearch.toolData': 'Dane Wyszukiwania Web',
    'webSearch.searchingFor': 'Wyszukiwanie',
    'webSearch.resultsFound': 'znalezionych wyników',
    'webSearch.noResultsFound': 'Nie znaleziono wyników',
    'webSearch.tryDifferentQuery': 'Spróbuj innego zapytania wyszukiwania',
    'webSearch.deepSearchEnabled': 'Wyszukiwanie Głębokie Włączone',
    'webSearch.contentExtracted': 'Treść wydobyta z',
    'webSearch.pages': 'stron',
    'webSearch.characters': 'znaków',
    'rag.searchingKnowledge': 'Przeszukiwanie bazy wiedzy',
    'rag.open_knowledge_preview': 'Otwórz podgląd wiedzy',
    'rag.openInKnowledgeBase': 'Podgląd',
    'rag.noFilesIncluded': 'Brak dołączonych plików',
    'rag.sources_used': 'Użyte źródła',
    'rag.sources': 'Źródła',
    'rag.open_sources': 'Wyświetl źródła',
    // Product Cards
    'productCard.toolData': 'Karty Produktów',
    'productCard.productList': 'Lista Produktów',
    'productCard.singleProduct': 'Pojedynczy Produkt',
    'productCard.product': 'produkt',
    'productCard.products': 'produkty',
    'productCard.grossPrice': 'Cena Brutto',
    'productCard.netPrice': 'Cena Netto',
    'productCard.vat': 'VAT',
    'productCard.category': 'Kategoria',
    'productCard.viewProduct': 'Zobacz Produkt',
    'productCard.noProducts': 'Nie znaleziono produktów',
    'productCard.trySearching': 'Spróbuj wyszukać produkty',
    // Product Compare Tool
    'productCompare.domain': 'Domena',
    'productCompare.comparing': 'Porównywanie',
    'productCompare.searchQuery': 'Zapytanie wyszukiwania',
    'productCompare.noResults': 'Nie znaleziono wyników porównania',
    // Detect Contact Data Tool
    'detectContactData.phoneNumbers': 'Numery telefonów',
    'detectContactData.emails': 'Adresy e-mail',
    'detectContactData.addresses': 'Adresy',
    'detectContactData.names': 'Imiona i nazwiska',
    'detectContactData.companies': 'Firmy',
    'detectContactData.socialMedia': 'Media społecznościowe',
    'detectContactData.websites': 'Strony internetowe',
    'detectContactData.other': 'Inne',
    'detectContactData.noData': 'Nie wykryto danych kontaktowych',
    // Detect Tasks Tool
    'detectTasks.notes': 'Notatki',
    'detectTasks.noTasks': 'Nie wykryto zadań',
    // Offer Creator Tool
    'offerCreator.companyName': 'Nazwa firmy',
    'offerCreator.firstName': 'Imię',
    'offerCreator.lastName': 'Nazwisko',
    'offerCreator.email': 'E-mail',
    'offerCreator.phone': 'Telefon',
    'offerCreator.vatPayer': 'Płatnik VAT',
    'offerCreator.employeesNumber': 'Liczba pracowników',
    'offerCreator.businessActivity': 'Działalność gospodarcza',
    'offerCreator.taxationType': 'Forma opodatkowania',
    'offerCreator.documentsNumber': 'Liczba dokumentów',
    'offerCreator.packageId': 'Pakiet',
    'offerCreator.additionalInfo': 'Dodatkowe informacje',
    'offerCreator.formSent': 'Formularz wysłany',
    'offerCreator.noData': 'Brak danych oferty',
    // Quick Offer Tool
    'quickOffer.availableOptions': 'Dostępne opcje',
    'quickOffer.formSent': 'Formularz wysłany',
    'quickOffer.noFields': 'Brak pól formularza',
    // Send Contact Form Tool
    'sendContactForm.name': 'Imię i nazwisko',
    'sendContactForm.email': 'E-mail',
    'sendContactForm.phone': 'Telefon',
    'sendContactForm.message': 'Wiadomość',
    'sendContactForm.formSent': 'Formularz kontaktowy wysłany',
    'sendContactForm.noData': 'Brak danych formularza kontaktowego',
    // Conversation Tags Tool
    'convoTags.noTags': 'Nie wykryto tagów',
    // Gallery Tags Tool
    'galleryTags.noTags': 'Nie wykryto tagów galerii',
    // Ask For Voucher Tool
    'askForVoucher.detected': 'Wykryto żądanie vouchera',
    'askForVoucher.notDetected': 'Nie wykryto żądania vouchera',
    // Dynamic Listings Tool
    'dynamicListings.listingsSignalled': 'ofert zasygnalizowanych',
    'dynamicListings.allListings': 'Wszystkie oferty zasygnalizowane',
    // Product API Search Tool
    'productAPISearch.searchQuery': 'Zapytanie wyszukiwania',
    'productAPISearch.totalResults': 'łączna liczba wyników',
    'productAPISearch.subcategories': 'podkategorie',
    'productAPISearch.noResults': 'Nie znaleziono wyników',
    // Google Drive
    // Knowledge Bulk Upload
    // Tutorial Form
    // Avatar RAG Settings
    // RAG Settings Component
    // Knowledge Form RAG Override
    // DB Logs page
    'dblogs.title': 'Logi audytowe bazy danych',
    'dblogs.show': 'Pokaż',
    'dblogs.hide': 'Ukryj',
    'dblogs.empty': 'Brak wpisów logów.',
    // DB model collection names
    'model.user': 'Użytkownik',
    'model.user_group': 'Grupa użytkowników',
    'model.api_keys': 'Klucze API',
    'model.acl_policy': 'Polityka ACL',
    'model.company': 'Firma',
    'model.conversation': 'Rozmowa',
    'model.message': 'Wiadomość',
    'model.avatar': 'Avatar',
    'model.user_avatar': 'Avatar użytkownika',
    'model.knowledge': 'Wiedza',
    'model.knowledgeGroup': 'Grupa wiedzy',
    'model.file': 'Plik',
    'model.training_job': 'Zadanie treningu',
    'model.avatar_knowledge': 'Wiedza avatara',
    'model.avatar_instruction': 'Instrukcja avatara',
    'model.avatar_instruction_version': 'Wersja instrukcji avatara',
    'model.profession_knowledge': 'Wiedza zawodowa',
    'model.profession_step': 'Krok zawodu',
    'model.custom_models': 'Model niestandardowy',
    'model.embeddings': 'Osadzenie',
    'model.branch': 'Gałąź',
    'model.profession': 'Zawód',
    'model.step': 'Krok',
    'model.step_profession': 'Krok zawodu',
    'model.onboarding': 'Wdrożenie',
    'model.db_logs': 'Log bazy danych',
    'model.question': 'Pytanie',
    'model.answer': 'Odpowiedź',
    'model.settings': 'Ustawienia',
    'model.usage_cost': 'Koszt użycia',
    'model.knowledge_elevenlabs_mappings': 'Mapowanie ElevenLabs wiedzy',
    'model.front_sync': 'Synchronizacja frontendu',
    'model.favorite_conversation': 'Ulubiona rozmowa',
    'model.style': 'Styl',
    'model.slotData': 'Dane slotu',
    'model.payments': 'Płatność',
    'model.account_balance': 'Saldo konta',
    'model.accountGrade': 'Poziom konta',
    'model.currencyRate': 'Kurs walut',
    'model.test_result': 'Wynik testu',
    'model.bot_test': 'Test bota',
    'model.bot_test_tester': 'Tester bota',
    'model.bot_test_target': 'Cel testu bota',
    'model.tutorial': 'Samouczek',
    'model.tutorial_step': 'Krok samouczka',
    'model.tutorial_section': 'Sekcja samouczka',
    'model.tutorial_section_knowledge': 'Wiedza sekcji samouczka',
    'model.tutorial_section_todo': 'Todo sekcji samouczka',
    'model.tutorial_participants': 'Uczestnik samouczka',
    'model.todo': 'Todo',
    'model.todo_item': 'Element todo',
    'model.todo_item_value': 'Wartość elementu todo',
    'model.cache': 'Cache',
    'model.api_tool_definition': 'Definicja narzędzia API',
    'login.form.subtitle': 'Zaloguj się, aby przejść do swoich szkoleń.',
    'nav.profile': 'Mój profil',
    // DB operation names
    // WhatsApp settings
    'socialMediaPlan.title': 'Content Studio',
    'socialMediaPlan.failedToLoad': 'Nie udało się załadować postów',
    'socialMediaPlan.newPost': 'Nowy post',
    'socialMediaPlan.library': 'Biblioteka postów',
    'socialMediaPlan.search': 'Szukaj posta lub tematu...',
    'socialMediaPlan.edit': 'Edytuj',
    'socialMediaPlan.ai.placeholder': "Napisz np: 'Zaproponuj 3 pomysły na Instagram'...",
    "socialMediaPlan.schedule.action": 'Co dalej?',
    'socialMediaPlan.back': 'Wstecz',
    'socialMediaPlan.next': 'Dalej',
    'socialMediaPlan.cancel': 'Anuluj',
    'socialMediaPlan.save': 'Zatwierdź i zapisz',
    'socialMediaPlan.close': 'Zamknij',
    'whatsapp.loginFailed': 'Logowanie WhatsApp nie powiodło się.',
    'whatsapp.logoutSuccess': 'WhatsApp wylogowany pomyślnie.',
    'whatsapp.logoutFailed': 'Wylogowanie z WhatsApp nie powiodło się.',
    'whatsapp.failedToLoad': 'Nie udało się załadować statusu WhatsApp.',
    'whatsapp.entityIdRequired': 'ID encji jest wymagane.',
    'whatsapp.phoneRequired': 'Numer telefonu jest wymagany.',
    'whatsapp.settingsSaved': 'Ustawienia WhatsApp zapisane pomyślnie.',
    'whatsapp.settingsSaveFailed': 'Nie udało się zapisać ustawień WhatsApp.',
    'whatsapp.agentStarted': 'Agent WhatsApp uruchomiony pomyślnie.',
    'whatsapp.agentStartFailed': 'Nie udało się uruchomić agenta WhatsApp.',
    'whatsapp.agentStopped': 'Agent WhatsApp zatrzymany pomyślnie.',
    'whatsapp.agentStopFailed': 'Nie udało się zatrzymać agenta WhatsApp.',
    // WhatsApp tabs
    // Comms Threads
    // WhatsApp email
    // WhatsApp groups
    // WhatsApp track logs
    // Activity panels
    // WhatsApp group form
    // WhatsApp dashboard
    // WhatsApp group routes
    // WhatsApp direct messages
    // WhatsApp DM detail page
    // Email Reporting Settings
    'whatsapp.pop3SettingsSaved': 'Ustawienia raportowania e-mail zapisane pomyślnie.',
    'whatsapp.pop3SettingsSaveFailed': 'Nie udało się zapisać ustawień e-mail.',
    // Gmail OAuth
    // ACL translations
    ...pl_1.aclTranslationsPl
};
